import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeletePackage } from "../../api/apiPackages";
import parseError from "../../utils/parseError";

const useForceDeletePackage = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeletePkg,
        isPending: isForceDelete,
    } = useMutation({
        mutationFn: forceDeletePackage,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["packages"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete package");
        },
    });

    return {
        forceDeletePkg,
        isForceDelete,
    };
};

export default useForceDeletePackage;
